// Module
var code = "<script>let $ctrl</script> <section class=\"atom-form-validation-error\"> <atom-text> <ng-transclude></ng-transclude> </atom-text> </section> ";
// Exports
module.exports = code;